import { ResolveFn } from '@angular/router';
import {resolveLogicalAccount} from './dollars-logical-account.resolver';
import {map} from 'rxjs/operators';

export const dollarsTitleResolver: ResolveFn<string> = (route) => {
    return resolveLogicalAccount(route).pipe(
		map(logicalAccount => logicalAccount.name)
	);
};
